import ReactDatePicker from 'react-datepicker';
import SelectSubAccountDropdown from '../../../../components/global-components/selectSubAccountDropdown';
import SelectProjectDropdown from '../../../../components/global-components/SelectProjectDropdown';
import SelectStatusDropdown from '../../../../components/global-components/SelectStatusDropdown';
import { ProjectStatus } from '../../../interfaces';
import './JobHistoryFilters.scss';

interface Props {
  startDate: Date | null;
  endDate: Date | null;
  onChangeDates: (dates: [Date | null, Date | null]) => void;
  onChangeRawDates: (event: React.FocusEvent<HTMLInputElement>) => void;
  projectCode: string;
  onChangeProjectCode: (projectCode: string) => void;
  status: ProjectStatus;
  onChangeStatus: (status: ProjectStatus) => void;
  statusesFilter: (status: ProjectStatus) => boolean;
  account: string;
  onChangeAccount: (account: string) => void;
  areFiltersChanged: boolean;
  onClickFilter: () => void;
  isAdmin: boolean;
}

export default function JobHistoryFilters({
  startDate,
  endDate,
  onChangeDates,
  onChangeRawDates,
  projectCode,
  onChangeProjectCode,
  status,
  onChangeStatus,
  statusesFilter,
  account,
  onChangeAccount,
  areFiltersChanged,
  onClickFilter,
  isAdmin = false,
}: Props) {
  return (
    <div className='JobHistoryFilters'>
      <div className='DateRangeContainer'>
        <label className='form-label labelText'>
          Date Range
        </label>
        <ReactDatePicker
          className='form-control ubbe-input DateRange'
          selected={startDate}
          startDate={startDate}
          endDate={endDate}
          onChange={onChangeDates}
          onChangeRaw={onChangeRawDates}
          placeholderText='Select dates'
          dateFormat='yyyy-MM-dd'
          monthsShown={2}
          calendarIconClassname='calendarIcon'
          showIcon
          selectsRange
        />
      </div>
      <div className='ProjectSelectContainer'>
        <label className='form-label labelText'>
          Project
        </label>
        <SelectProjectDropdown
          selectedProject={projectCode}
          setSelectedProject={onChangeProjectCode}
          setHandleToggleChange={() => {}}
        />
      </div>
      <div className='StatusSelectContainer'>
        <label className='form-label labelText'>
          Status
        </label>
        <SelectStatusDropdown
          selectedStatus={status}
          setSelectedStatus={onChangeStatus}
          setHandleToggleChange={() => {}}
          statusesFilter={statusesFilter}
        />
      </div>
      {isAdmin && (
        <div className='AccountsContainer'>
          <label className='form-label labelText'>
            Accounts
          </label>
          <SelectSubAccountDropdown
            setSelectedSubAccount={onChangeAccount}
            selectedSubAccount={account}
          />
        </div>
      )}
      <button
        className={`FilterButton ${areFiltersChanged ? 'active-filter' : 'disable-filter'}`}
        onClick={onClickFilter}
        disabled={!areFiltersChanged}
      >
        Filter
      </button>
    </div>
  );
}
